<template>
  <nav
    class="
      navbar navbar-expand-lg navbar-light
      bg-primary
      d-flex
      flex-column
      pb-0
    "
  >
    <div class="container-xl d-flex justify-content-between">
      <a
        id="backToRobvq"
        class="navbar-brand text-ternary text-600"
        href="https://www.robvq.qc.ca"
      >
        <AppIcon :icon="['fa-light', 'fa-long-arrow-left']" />
        Retour vers robvq.qc.ca
      </a>
      <div v-if="showTokenNumber" class="token-wrapper navbar-nav">
        <TokenNumber />
      </div>
      <div>
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <UserButton />
        </div>
      </div>
    </div>
    <div class="container-xl d-flex justify-content-between">
      <a class="navbar-brand" href="https://robvq.qc.ca/gdep">
        <img src="/images/GDEP_white.png" width="166" height="44" alt="GDEP" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarScroll"
        aria-controls="navbarScroll"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="filter: grayscale(1) invert(1)"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="navbarScroll" class="collapse navbar-collapse flex-row-reverse">
        <ul class="navbar-nav my-2 my-lg-0">
          <template v-for="[title, link, key] in wpMenu">
            <DropdownMenu
              v-if="isDropdownMenu(link)"
              :key="key"
              :title="title"
              :content="link"
              :base-uri="gdepBaseUri"
            />
            <li v-else :key="key" class="nav-item hover-pointer">
              <a
                :class="link !== null ? 'text-white' : 'text-ternary active'"
                class="nav-link"
                :href="buildLink(link)"
              >
                {{ title }}
              </a>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import TokenNumber from './TokenNumber.vue'
import UserButton from './UserButton.vue'
import DropdownMenu from './DropdownMenu.vue'
export default {
  components: { UserButton, TokenNumber, DropdownMenu },
  data() {
    return {
      wpMenu: new Map([
        [
          'À propos',
          new Map([
            [
              'La GDEP : une solution pour soutenir l’adaptation aux changements climatiques',
              '/',
            ],
            ['Les architectes du projet', '/les-architectes-du-projet/'],
          ]),
        ],
        ['S’inspirer', '/sinspirer/'],
        ['S’évaluer', 'https://gdep.robvq.qc.ca'],
        [
          'S’outiller',
          new Map([
            ['En résumé', '/soutiller/'],
            [
              'Outils d’introduction à la GDEP',
              '/outils-dintroduction-a-la-gdep/',
            ],
            ['Outils de planification', '/outils-de-planification/'],
            ['Outils de mise en oeuvre', '/outils-de-mise-en-oeuvre/'],
          ]),
        ],
        ['Contact', '/contact/'],
      ]),
    }
  },
  computed: {
    showTokenNumber() {
      return this.$page.props.is_guest && this.$page.props.survey.token
    },
    gdepBaseUri() {
      return 'https://robvq.qc.ca/gdep'
    },
  },
  methods: {
    isDropdownMenu(link) {
      return link && link instanceof Map
    },
    buildLink(link) {
      if (link.startsWith('http')) {
        return link
      }
      return this.gdepBaseUri + link
    },
  },
}
</script>
<style lang="scss" scoped>
li.nav-item {
  padding-bottom: 33px;
  place-self: baseline;
}
a.nav-link {
  white-space: nowrap;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
  text-decoration: none;
  transition: color 0.4s ease-in-out;
  border-bottom: 2px solid transparent;
  &.active {
    border-bottom: 2px solid var(--bs-ternary);
  }
  &:hover {
    text-decoration: none;
    color: var(--bs-ternary);
  }
}

#backToRobvq {
  transition: all 0.4s ease-in-out;

  transform: translateX(1em);
  &:hover {
    transform: translateX(0);
    filter: opacity(0.7);
    font-weight: 900;
    text-decoration: none;
  }
}
</style>
